<template lang="pug">
  include Login.pug
</template>

<script>
import Lockr from "lockr";
import _ from "underscore";
import api from "@/service/api";

const validateEmail = (email) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export default {
  name: "Login",
  data: function () {
    return {
      message: null,
      error: null,
      mode: "login",
      username: "",
      password: "",
      password2: "",
    };
  },
  created() {
    const token = this.$store.state.token;
    if (token) {
      this.$router.push({
        name: "Dashboard",
      });
    }
  },
  methods: {
    doRegister: async function () {
      this.error = null;
      let username = this.username
      if (username && username.length) username = username.trim()

      if (!validateEmail(username)) {
        this.error = "El correo electrónico no es un correo electrónico válido";
        return;
      }

      if (
        _.isEmpty(username) ||
        _.isEmpty(this.password) ||
        _.isEmpty(this.password2)
      ) {
        this.error = "Por favor, introduzca las credenciales de acceso";
        return;
      }

      if (this.password != this.password2) {
        this.error = "Las contraseñas no coinciden";
        return;
      }

      if (this.password.length < 6) {
        this.error =
          "La contraseña tiene que tener una longitud mínima de 6 carácteres";
        return;
      }

      const result = await api.register(username, this.password);
      const token = result.data.token;

      if (token) {
        this.$store.commit("setUsername", username);
        this.$store.commit("setToken", token);
        this.redirectToView();
      } else {
        this.error = "Error en el proceso de registro. Inténtelo más tarde";
      }
    },
    redirectToView: function () {
      const uuid = Lockr.get("cop_promo");
      if (uuid) {
        this.$router.push({
          name: "Promotion",
          params: {
            uuid,
          },
        });
      } else {
        this.$router.push({
          name: "Stats",
        });
      }
    },
    doLogin: async function () {
      this.error = null;

      if (_.isEmpty(this.username) || _.isEmpty(this.password)) {
        this.error = "Por favor, introduzca las credenciales de acceso"
        return;
      }
      let username = this.username
      if (username) username = username.trim()

      const result = await api.login(username, this.password)

      // detect first if an error has been detected on login
      if (result.data.error) {
        const error = result.data.error

        if (error == 'ERROR:WRONG_PASSWORD') {
          this.error = "Contraseña incorrecta. Puede usar el enlace de '¿Olvidate tu contraseña?' para pedir una contraseña nueva."
        } else {
          this.error = "El usuario indicado no existe."
        }

      } else {
        // login sucessfull
        const token = result.data.token

        if (token) {
          this.$store.commit("setUsername", username)
          this.$store.commit("setToken", token)
          this.redirectToView()
        } else {
          this.error = "Error en usuario y/o contraseña"
        }
      }
    },
    doRecover: async function () {
      if (!this.username || !this.username.length) return;
      const result = await api.requestRecover(this.username);
      this.message =
        "Se ha enviado un enlace de recuperación a la dirección de correo electrónico indicada";
      this.username = "";
    },
  },
  watch: {
    username: function (oldVal, newVal) {
      this.error = null;
    },
    password: function (oldVal, newVal) {
      this.error = null;
    },
  },
};
</script>
